import { createReducer, on } from '@ngrx/store';
import * as CoreActions from './core.actions';
import { LanguageType, LunePreferences } from '@icilalune/types';
import { Breakpoint } from '@icilalune/utils/responsive';

export const coreFeatureKey = 'core';

export interface State {
  standByToolBar: boolean;
  breakpoint?: Breakpoint;
  elevatorIndex: number;
  elevatorRatio: number;
  language?: LanguageType;
  languageSwitching?: boolean;
  preferences?: LunePreferences | null;
  appReady?: boolean;
}

export const initialState: State = {
  standByToolBar: false,
  elevatorIndex: 0,
  elevatorRatio: 0,
};

export const reducer = createReducer(
  initialState,
  on(CoreActions.appReady, (state) => {
    return {
      ...state,
      appReady: true,
    };
  }),
  on(CoreActions.updateStandByToolBar, (state, { standBy }) => {
    return {
      ...state,
      standBy,
    };
  }),
  on(CoreActions.setBreakpoint, (state, { breakpoint }) => {
    return {
      ...state,
      breakpoint,
    };
  }),
  on(CoreActions.setElevatorIndex, (state, { index }) => {
    return {
      ...state,
      elevatorIndex: index,
    };
  }),
  on(CoreActions.setElevatorRatio, (state, { ratio }) => {
    return {
      ...state,
      elevatorRatio: ratio,
    };
  }),
  on(CoreActions.switchLanguage, (state, { language }) => {
    return {
      ...state,
      language,
      languageSwitching: true,
    };
  }),
  on(CoreActions.setPreferences, (state, { preferences }) => {
    return {
      ...state,
      preferences,
    };
  })
);
